import { isMobileResolution } from "./utils/utils";

function throttle<T extends (this: any, ...args: any[]) => any>(func: T, ms: number) {
  let isThrottled = false;
  let savedArgs: Parameters<T> | null = null;
  let savedThis: ThisParameterType<T> | null = null;

  function wrapper(this: ThisParameterType<T>, ...args: Parameters<T>) {
    if (isThrottled) {
      savedArgs = args;
      savedThis = this;
      return;
    }

    func.apply(this, args);
    isThrottled = true;

    setTimeout(() => {
      isThrottled = false;

      if (savedArgs) {
        wrapper.apply(savedThis!, savedArgs);

        savedArgs = null;
        savedThis = null;
      }
    }, ms);
  }

  return wrapper;
}

export const initScrollBoostBlock = () => {
  const fixedRow = document.querySelector(".fixed-row");

  if (!fixedRow || isMobileResolution()) return;

  window.addEventListener(
    "scroll",
    throttle(() => {
      const scrollY = window.scrollY;
      const bodyHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;

      const distanceToBottom = bodyHeight - (scrollY + windowHeight);

      if (scrollY > 800 && distanceToBottom > 700) {
        fixedRow.classList.add("--visible");
      } else {
        fixedRow.classList.remove("--visible");
      }
    }, 200),
  );
};

export const initTeamDragScroll = () => {
  const blocks = document.querySelectorAll<HTMLElement>(".team__block");

  blocks.forEach((el) => {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    el.addEventListener("pointerdown", (e) => {
      if (e.pointerType !== "mouse" && e.pointerType !== "pen") return;

      isDown = true;
      startX = e.clientX;
      scrollLeft = el.scrollLeft;
      el.classList.add("is-dragging");
      el.setPointerCapture(e.pointerId);
    });

    el.addEventListener("pointermove", (e) => {
      if (!isDown) return;

      el.scrollLeft = scrollLeft - (e.clientX - startX);
    });

    const end = () => {
      if (!isDown) return;

      isDown = false;
      el.classList.remove("is-dragging");
    };

    el.addEventListener("pointerup", end);
    el.addEventListener("pointercancel", end);
  });
};
